module.exports = __webpack_public_path__ + "static/media/train15.ee1bd2d2.png";